import { WHEN_BLOCK } from 'constants/MeshbotConstant';
import { getControllerItems } from 'helpers/getControllerItems';

import { getCapabilityBehaviorByValueType } from './capabilityDynamicFieldsConfig';
import { getFieldByName } from './getFieldByName';
import { getItemById } from './getItemById';
import { isExistingUserCodeKey } from './isExistingUserCodeKey';
import { isPinRequiredForAction } from './isPinRequiredForAction';

/**
 * Validates an isUserLockOperation when-block for the Save-button gate (shared by all value types of this method).
 * Reads the block's `fields` (the form validation runs on selectedRule.when, which carries blocks, not
 * capabilityDynamicFields). Valid when an action is selected and, for a PIN-requiring action, the PIN key exists in
 * the device's user_codes dictionary (empty or orphan key → invalid). Actions that need no PIN are valid on their
 * own. Fetches the controller items it needs itself (validate's contract is just the block), so configs whose
 * validate needs no items pass nothing extra. The dictionary lookup is id-first (see isExistingUserCodeKey).
 * @param {Object} block - when-block ({ fields: [item, state, user] }) or {} when nothing is selected yet
 * @returns {boolean}
 */
export const isUserLockOperationTriggerValid = (block) => {
    const stateFieldValue = getFieldByName(block?.fields, WHEN_BLOCK.STATE)?.value;

    if (!stateFieldValue) {
        return false;
    }

    const items = getControllerItems();
    const itemFieldValue = getFieldByName(block?.fields, WHEN_BLOCK.ITEM)?.value;
    const item = getItemById(items, itemFieldValue);
    const actionOptions = getCapabilityBehaviorByValueType(item?.valueType)?.actionOptions;

    if (!isPinRequiredForAction(actionOptions, stateFieldValue)) {
        return true;
    }

    const userField = getFieldByName(block?.fields, WHEN_BLOCK.USER);

    return isExistingUserCodeKey(userField?.value, userField?.optionItemValue?.itemId, items, item?.deviceId);
};
